import {Tag} from 'antd';
import {ReactElement} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {blue95, danger95, gray9} from '../../../../../../../../css/var-export.scss';
import {classNames} from '../../../../../../../../util/css';

import * as styles from './status-tag.scss';

type PropsType = {
    isDeleted: boolean;
    isHidden: boolean;
    lastChangesDate: string | null;
    openHistoryModalHandler: () => void;
};

export function StatusTag(props: PropsType): ReactElement | null {
    const {isDeleted, isHidden, lastChangesDate, openHistoryModalHandler} = props;

    if (isDeleted) {
        return (
            <Tag className={styles.StatusTag} color={danger95}>
                <Text className={styles.StatusTag_danger__text} small stringKey="REVIEWS__REVIEW_DELETED" />
            </Tag>
        );
    }

    if (isHidden) {
        return (
            <Tag className={classNames(styles.StatusTag, styles.StatusTag_hidden)} color={gray9}>
                <Text className={styles.StatusTag_hidden__text} small stringKey="REVIEWS__REVIEW_HIDDEN" />
            </Tag>
        );
    }

    if (lastChangesDate) {
        return (
            <Tag
                className={classNames(styles.StatusTag, styles.StatusTag_changed)}
                color={blue95}
                onClick={openHistoryModalHandler}
            >
                <Text
                    className={styles.StatusTag_changed__text}
                    small
                    stringKey="REVIEWS__FILTER__LABEL__REVIEW_CHANGED"
                />
            </Tag>
        );
    }

    return null;
}
